import s from "./style.module.scss";
import React from "react";

type props = {
  text?: string;
};

const GuaranteedCheckout = ({ text }: props) => (
  <fieldset className={s.checkout}>
    <legend>{text}</legend>
    <div className={s.checkout__aes}>
      <img
        src={`${window.template_root}/v1/onetime/safecheckout/shield.svg`}
        alt="AES-256bit"
        width={40}
        height={41}
      />
      <p>AES-256bit</p>
    </div>
    <img
      className={s.checkout__paypal}
      src={`${window.template_root}/v1/onetime/safecheckout/Paypal.svg`}
      alt="paypal"
      width={40}
      height={57}
    />
    <div className={s.checkout__cards}>
      <img
        src={`${window.template_root}/v1/onetime/safecheckout/cards/visa.svg`}
        alt="visa"
        width={36}
        height={25}
      />
      <img
        src={`${window.template_root}/v1/onetime/safecheckout/cards/mastercard.svg`}
        alt="mastercard"
        width={36}
        height={25}
      />
      <img
        src={`${window.template_root}/v1/onetime/safecheckout/cards/Amex.svg`}
        alt="amex"
        width={36}
        height={25}
      />
      <img
        src={`${window.template_root}/v1/onetime/safecheckout/cards/discover.svg`}
        alt="discover"
        width={36}
        height={25}
      />
    </div>
  </fieldset>
);

export default GuaranteedCheckout;
